// prop-type is a library for typechecking of props
// import PropTypes from 'prop-types';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';
import ArgonInput from 'component/Argon/ArgonInput';

function FormField({ label, ml, ...rest }) {
  return (
    <>
      {label && (
        <ArgonBox mb={1} ml={ml !== undefined ? ml : 0.5} lineHeight={0} display="inline-block">
          <ArgonTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
            {label}
          </ArgonTypography>
        </ArgonBox>
      )}
      <ArgonInput {...rest} />
    </>
  );
}

// typechecking props for FormField
// FormField.propTypes = {
//   label: PropTypes.string,
// };

export default FormField;
